import {DomainEvent} from './DomainEvent';
import type {EntityExportRequest} from './EntityExportRequest';
import type {Iso8601DateString} from '@fupa/fupa-ts-core';

export interface MatchesExportRequest extends EntityExportRequest {
  /** the kickoff date of the matches to start the export for */
  readonly from: Iso8601DateString;
  /** the kickoff date of the matches to end the export for */
  readonly to: Iso8601DateString;
}

/**
 * This event can be fired to indicate that a service requires matches within a specific date interval.
 * Another service that is eligible to provide this info will put batches of the requested matches into
 * the specified S3 {@see MatchesExportRequest.targetBucket} using
 * the {@see MatchesExportRequest.transactionId} as prefix (sub-folder).
 */
export class MatchesExportRequested extends DomainEvent<MatchesExportRequest> {}
